import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=0a5bc099&scoped=true&"
import script from "./Mailings.vue?vue&type=script&lang=js&"
export * from "./Mailings.vue?vue&type=script&lang=js&"
import style0 from "./Mailings.vue?vue&type=style&index=0&id=0a5bc099&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bc099",
  null
  
)

export default component.exports